exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-margin[data-v-32972dfc] {\n  margin-bottom: 7px;\n}\n.micha-sidenav-font[data-v-32972dfc] {\n  font-weight: 400 !important;\n  text-decoration: underline !important;\n}", ""]);

// exports
